import List from './list'
import Details from './details'
import Update from './update'

export default {
  list: List,
  details: Details,
  update: Update
}
